import { FooterTheme } from '../types';
import { colors } from '../constants/colors';
import { Instagram, Pinterest, Facebook, Youtube, Tiktok, X } from '../icons';

export const footer: FooterTheme = {
  customSocialBlock: [
    {
      href: 'https://www.facebook.com/johnlewisretail',
      title: 'Facebook opens in a new tab',
      hoverColor: colors.white,
      ariaLabel: 'Facebook',
      icon: Facebook,
    },
    {
      href: 'https://x.com/JohnLewisRetail',
      title: 'X opens in a new tab',
      hoverColor: colors.white,
      ariaLabel: 'X',
      icon: X,
    },
    {
      href: 'https://www.youtube.com/JohnLewisandPartners',
      title: 'Youtube opens in a new tab',
      hoverColor: colors.white,
      ariaLabel: 'Youtube',
      icon: Youtube,
    },
    {
      href: 'https://www.pinterest.co.uk/johnlewis/',
      title: 'Pinterest opens in a new tab',
      hoverColor: colors.white,
      ariaLabel: 'Pinterest',
      icon: Pinterest,
    },
    {
      href: 'https://www.instagram.com/johnlewis/',
      title: 'Instagram opens in a new tab',
      hoverColor: colors.white,
      ariaLabel: 'Instagram',
      icon: Instagram,
    },
    {
      href: 'https://www.tiktok.com/@johnlewis',
      title: 'TikTok opens in a new tab',
      hoverColor: colors.white,
      ariaLabel: 'TikTok',
      icon: Tiktok,
    },
  ],
  legalBlock: {
    color: colors.white,
    isFullWidth: true,
  },
  customLinksHoverColor: colors.white,
  bgColor: colors.jlMoneyGreenDark,
  customLinksColor: colors.white,
  dividerColor: colors.white,
  showFooterLinks: true,
  showSocialBlock: true,
  showLogoBlock: false,
  showLegalBlock: true,
  className: 'pt-8',

  showDivider: true,
};
